import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { H2Atom, H4Atom, PAtom } from '../../../atoms/text-atoms/text-atoms';
import { AAtom } from '../../../atoms/link-atoms/link-atoms';
import vars from '../../../variables';
import GcDropDown from '../gc-dropdown/gc-dropdown';
import { GTM_ID } from '../../../../../common/constants/gtmIds';

const SubHeader = ({
  title,
  category,
  firstYearReport = 'FALSE',
  previousYearSlug,
  organisationListingUrl,
  linkData,
  className,
}) => {
  const sortedLinks = linkData
    ? linkData.sort((a, b) => a.name.localeCompare(b.name))
    : undefined;
  const listingUrl = organisationListingUrl;
  const previousYearUrl = previousYearSlug
    ? `https://emf.thirdlight.com/link/dixih8awlegz-p6qi9q/@/#`
    : undefined;
  return (
    <div data-testid="gc-sub-header" className={className}>
      <div className="sub-header-row-wrap">
        <div className="left-column">
          {title && <H2Atom>{title}</H2Atom>}
          {category && <H4Atom>{category}</H4Atom>}
        </div>
        <div className="right-column">
          {previousYearUrl && (
            <AAtom href={previousYearUrl} target="_blank">
              See 2020 reports
            </AAtom>
          )}
          {!previousYearSlug &&
            firstYearReport &&
            firstYearReport.trim() === 'TRUE' && (
              <PAtom className="first-year">First Year</PAtom>
            )}
        </div>
      </div>
      <div className="sub-header-row-wrap">
        <div className="left-column">
          <GcDropDown sortedLinks={sortedLinks} />
        </div>
        <div className="right-column">
          {listingUrl && (
            <AAtom
              href={listingUrl}
              data-gtm-id={GTM_ID.BACK_TO_SIGNATORY_REPORT_LINK}
            >
              Back to signatory report page
            </AAtom>
          )}
        </div>
      </div>
    </div>
  );
};

SubHeader.propTypes = {
  title: PropTypes.string,
  category: PropTypes.string,
  firstYearReport: PropTypes.string,
  organisationListingUrl: PropTypes.string,
  linkData: PropTypes.array,
  hasPreviousYearLink: PropTypes.string,
};

const StyledSubHeader = styled(SubHeader)`
  background-color: ${vars.white};
  margin-bottom: 0;
  padding-bottom: 1.2rem;

  .sub-header-row-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .left-column {
      max-width: 75%;
    }
    .right-column {
      text-align: right;
      margin-left: 0;
      padding-top: 0.8rem;
      ${PAtom}.first-year {
        background-color: ${vars.plasticsBlue};
        padding: 0.3rem 1.2rem;
        border-radius: 0.4rem;
        color: ${vars.white};
        ${vars.fontSize1}
        margin-left: 2rem;
      }
    }
  }

  ${H2Atom} {
    padding-bottom: 1.2rem;
  }

  ${H4Atom} {
    padding-bottom: 1.7rem;
  }

  ${AAtom} {
    font-weight: ${vars.fontWeightRegular};
    ${vars.fontSize2}
    color: ${vars.plasticsBlue};
  }

  select {
    padding: 1rem 1rem 0.8rem 1rem;
  }
`;

export default StyledSubHeader;
